import {type IListSortOption} from "../types/IListSortOption";
import {ListSortOption} from "../types/ListSortOption";
import {LIST_SORT_OPTION_LABELS} from "./list_sort_option_labels";

export enum ListSortContext {
    APPLICATIONS = "applications",
    FAVORITES = "favorites"
}

const DATE_SORT_BY_CONTEXT = {
    [ListSortContext.APPLICATIONS]: {newest: ListSortOption.NEWEST, oldest: ListSortOption.OLDEST},
    [ListSortContext.FAVORITES]: {newest: ListSortOption.NEWEST, oldest: ListSortOption.OLDEST}
} as const;

export const getDefaultListSortOption = (context: ListSortContext): ListSortOption => DATE_SORT_BY_CONTEXT[context].newest;

const createListSortOptions = (context: ListSortContext): IListSortOption<ListSortOption>[] => {
    const {newest, oldest} = DATE_SORT_BY_CONTEXT[context];

    return [
        {...LIST_SORT_OPTION_LABELS.DATE_NEWEST, type: newest},
        {...LIST_SORT_OPTION_LABELS.DATE_OLDEST, type: oldest},
        {...LIST_SORT_OPTION_LABELS.PRICE_CHEAPEST, type: ListSortOption.CHEAPEST},
        {...LIST_SORT_OPTION_LABELS.PRICE_MOST_EXPENSIVE, type: ListSortOption.MOST_EXPENSIVE},
        {...LIST_SORT_OPTION_LABELS.AREA_BIGGEST, type: ListSortOption.BIGGEST},
        {...LIST_SORT_OPTION_LABELS.AREA_SMALLEST, type: ListSortOption.SMALLEST}
    ];
};

export const LIST_SORT_OPTIONS_BY_CONTEXT: Record<ListSortContext, IListSortOption<ListSortOption>[]> = {
    [ListSortContext.APPLICATIONS]: createListSortOptions(ListSortContext.APPLICATIONS),
    [ListSortContext.FAVORITES]: createListSortOptions(ListSortContext.FAVORITES)
};
import {type IListSortOption} from "../types/IListSortOption";
import {ListSortOption} from "../types/ListSortOption";
import {LIST_SORT_OPTION_LABELS} from "./list_sort_option_labels";

export enum ListSortContext {
    APPLICATIONS = "applications",
    FAVORITES = "favorites"
}

const DATE_SORT_BY_CONTEXT = {
    [ListSortContext.APPLICATIONS]: {newest: ListSortOption.NEWEST, oldest: ListSortOption.OLDEST},
    [ListSortContext.FAVORITES]: {newest: ListSortOption.NEWEST, oldest: ListSortOption.OLDEST}
} as const;

export const getDefaultListSortOption = (context: ListSortContext): ListSortOption => DATE_SORT_BY_CONTEXT[context].newest;

const createListSortOptions = (context: ListSortContext): IListSortOption<ListSortOption>[] => {
    const {newest, oldest} = DATE_SORT_BY_CONTEXT[context];

    return [
        {...LIST_SORT_OPTION_LABELS.DATE_NEWEST, type: newest},
        {...LIST_SORT_OPTION_LABELS.DATE_OLDEST, type: oldest},
        {...LIST_SORT_OPTION_LABELS.PRICE_CHEAPEST, type: ListSortOption.CHEAPEST},
        {...LIST_SORT_OPTION_LABELS.PRICE_MOST_EXPENSIVE, type: ListSortOption.MOST_EXPENSIVE},
        {...LIST_SORT_OPTION_LABELS.AREA_BIGGEST, type: ListSortOption.BIGGEST},
        {...LIST_SORT_OPTION_LABELS.AREA_SMALLEST, type: ListSortOption.SMALLEST}
    ];
};

export const LIST_SORT_OPTIONS_BY_CONTEXT: Record<ListSortContext, IListSortOption<ListSortOption>[]> = {
    [ListSortContext.APPLICATIONS]: createListSortOptions(ListSortContext.APPLICATIONS),
    [ListSortContext.FAVORITES]: createListSortOptions(ListSortContext.FAVORITES)
};
